(() => {
  if (window.__eventFlyerHandlersAttached) {
    return;
  }
  window.__eventFlyerHandlersAttached = true;

  const toAbsoluteUrl = (url) => {
    try {
      return new URL(url, window.location.origin).toString();
    } catch (error) {
      return window.location.href;
    }
  };

  const setTemporaryButtonState = (button, text) => {
    if (!button) {
      return;
    }

    const defaultLabel = button.dataset.defaultLabel || button.textContent || "Share";
    button.textContent = text;

    window.setTimeout(() => {
      button.textContent = defaultLabel;
    }, 1800);
  };

  const triggerAutoDownload = (section) => {
    if (!section || section.dataset.eventFlyerAutoDownload !== "true") {
      return;
    }

    const downloadLink = section.querySelector("[data-event-flyer-download]");
    if (!downloadLink) {
      return;
    }

    window.setTimeout(() => {
      downloadLink.click();
    }, 150);
  };

  const copyToClipboard = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }

    const tempInput = document.createElement("input");
    tempInput.value = value;
    tempInput.setAttribute("readonly", "");
    tempInput.style.position = "absolute";
    tempInput.style.left = "-9999px";
    document.body.appendChild(tempInput);
    tempInput.select();
    const copied = document.execCommand("copy");
    tempInput.remove();

    return copied;
  };

  document.addEventListener("click", async (event) => {
    const shareButton = event.target.closest("[data-event-flyer-share]");
    if (shareButton) {
      const shareUrl = toAbsoluteUrl(shareButton.dataset.shareUrl || window.location.href);
      const shareTitle = shareButton.dataset.shareTitle || document.title;
      const copiedLabel = shareButton.dataset.copiedLabel || "Copied";

      try {
        if (navigator.share) {
          await navigator.share({
            title: shareTitle,
            url: shareUrl
          });
        } else {
          await copyToClipboard(shareUrl);
          setTemporaryButtonState(shareButton, copiedLabel);
        }
      } catch (error) {
        if (error && error.name !== "AbortError") {
          await copyToClipboard(shareUrl);
          setTemporaryButtonState(shareButton, copiedLabel);
        }
      }

      return;
    }

    const controlButton = event.target.closest("[data-event-flyer-control]");
    if (!controlButton) {
      return;
    }

    const section = controlButton.closest("[data-event-flyer-section]");
    const track = section ? section.querySelector("[data-event-flyer-track]") : null;
    if (!track) {
      return;
    }

    const direction = controlButton.dataset.eventFlyerControl === "prev" ? -1 : 1;
    const distance = track.clientWidth * 0.9;

    track.scrollBy({
      left: direction * distance,
      behavior: "smooth"
    });
  });

  const autoDownloadSections = document.querySelectorAll("[data-event-flyer-section]");
  autoDownloadSections.forEach(triggerAutoDownload);
})();
